import type { AuditEntry } from "@/api/reports";

/** Bilingual labels for audit actions. Shared by the audit log and the dashboard. */
export const ACTION_LABEL: Record<string, { nl: string; en: string }> = {
  login_success: { nl: "Ingelogd", en: "Logged in" },
  login_failed: { nl: "Mislukte login", en: "Failed login" },
  platform_admin_created: { nl: "Platform-beheerder aangemaakt", en: "Platform admin created" },
  tenant_created: { nl: "Tenant aangemaakt", en: "Tenant created" },
  tenant_renamed: { nl: "Tenant hernoemd", en: "Tenant renamed" },
  tenant_deleted: { nl: "Tenant verwijderd", en: "Tenant deleted" },
  tenant_branding_updated: { nl: "Huisstijl gewijzigd", en: "Branding updated" },
  user_created: { nl: "Gebruiker aangemaakt", en: "User created" },
  user_updated: { nl: "Gebruiker gewijzigd", en: "User updated" },
  user_deleted: { nl: "Gebruiker verwijderd", en: "User deleted" },
  password_reset_requested: { nl: "Wachtwoord-reset aangevraagd", en: "Password reset requested" },
  password_reset: { nl: "Wachtwoord hersteld", en: "Password reset" },
  password_set: { nl: "Wachtwoord ingesteld", en: "Password set" },
  password_changed: { nl: "Wachtwoord gewijzigd", en: "Password changed" },
  segment_created: { nl: "Segment aangemaakt", en: "Segment created" },
  segment_updated: { nl: "Segment gewijzigd", en: "Segment updated" },
  segment_deleted: { nl: "Segment verwijderd", en: "Segment deleted" },
  module_created: { nl: "Module aangemaakt", en: "Module created" },
  module_updated: { nl: "Module gewijzigd", en: "Module updated" },
  module_published: { nl: "Module gepubliceerd", en: "Module published" },
  module_archived: { nl: "Module gearchiveerd", en: "Module archived" },
  module_acknowledged: { nl: "Akkoord gegeven", en: "Acknowledged" },
  quiz_saved: { nl: "Kennischeck opgeslagen", en: "Quiz saved" },
  quiz_deleted: { nl: "Kennischeck verwijderd", en: "Quiz deleted" },
  quiz_attempted: { nl: "Kennischeck gemaakt", en: "Quiz attempted" },
  journey_created: { nl: "Traject aangemaakt", en: "Journey created" },
  journey_updated: { nl: "Traject gewijzigd", en: "Journey updated" },
  journey_status_changed: { nl: "Traject-status gewijzigd", en: "Journey status changed" },
  journey_step_added: { nl: "Trajectstap toegevoegd", en: "Journey step added" },
};

export function actionLabel(action: string, t: (nl: string, en: string) => string): string {
  const entry = ACTION_LABEL[action];
  return entry ? t(entry.nl, entry.en) : action;
}

export function auditSummary(e: AuditEntry): string {
  if (!e.details) return "";
  const d = e.details;
  return ["email", "name", "slug", "title", "role", "status", "version_no", "score", "passed"]
    .filter((k) => k in d)
    .map((k) => `${k}: ${String(d[k])}`)
    .join(" · ");
}
